// utils/discountUtils.js
export const discountUtils = {
    hasDiscount: (item) => {
        // Check if discountInfo exists and hasDiscount is true
        if (item.discountInfo &&
            typeof item.discountInfo === "object" &&
            item.discountInfo.hasDiscount === true) {
            return true;
        }

        // Fallback: check if originalPrice exists and differs from price
        if (item.originalPrice &&
            typeof item.originalPrice === "number" &&
            typeof item.price === "number" &&
            item.originalPrice !== item.price) {
            return true;
        }

        return false;
    },

    calculateSavings: (item) => {
        if (!discountUtils.hasDiscount(item)) return 0;

        // Use originalPrice if available, otherwise use discountInfo
        if (item.originalPrice && item.originalPrice !== item.price) {
            return (item.originalPrice - item.price) * (item.quantity || 1);
        }

        // If no originalPrice, try to calculate from discountInfo
        if (item.discountInfo?.discountType && item.discountInfo?.discountValue) {
            const basePrice = item.price;
            let originalPrice;

            if (item.discountInfo.discountType === "percentage") {
                originalPrice = basePrice / (1 - item.discountInfo.discountValue / 100);
            } else {
                originalPrice = basePrice + item.discountInfo.discountValue;
            }

            return (originalPrice - basePrice) * (item.quantity || 1);
        }

        return 0;
    },

    getDiscountBadgeClass: (item) => {
        return item.discountInfo?.isVariantDiscount ? "product-badge variant-discount" : "product-badge product-discount";
    },

    getDiscountLabel: (item) => {
        return item.discountInfo?.discountLabel || "Discount";
    }
};